import { SharedPOSPage } from "./SharedPOSPage";
import { BAR_POS_CONFIG } from "./posConfig";

export const BarPOSPage = () => <SharedPOSPage config={BAR_POS_CONFIG} />;
